const model = [
  {
    SEQ_MODELO_VIEWER: 3,
    COD_MODELO_VIEWER: "01",
    TIP_MODELO: 1,
    DSC_MENSAGEM_VIEWER: "Teste 01",
    VLR_TEMPO_ATUALIZACAO: 10,
    PRD057_ASSOC_MODELO_PAR_MAQ: [{ SEQ_PARTE_MAQUINA: 1 }]
  },
  {
    SEQ_MODELO_VIEWER: 4,
    COD_MODELO_VIEWER: "02",
    TIP_MODELO: 2,
    DSC_MENSAGEM_VIEWER: "Teste 02",
    VLR_TEMPO_ATUALIZACAO: 20,
    PRD057_ASSOC_MODELO_PAR_MAQ: [{ SEQ_PARTE_MAQUINA: 1 }]
  },
  {
    SEQ_MODELO_VIEWER: 5,
    COD_MODELO_VIEWER: "03",
    TIP_MODELO: 3,
    DSC_MENSAGEM_VIEWER: "Teste 03",
    VLR_TEMPO_ATUALIZACAO: 30,
    PRD057_ASSOC_MODELO_PAR_MAQ: [{ SEQ_PARTE_MAQUINA: 1 }]
  },
  {
    SEQ_MODELO_VIEWER: 6,
    COD_MODELO_VIEWER: "04",
    TIP_MODELO: 4,
    DSC_MENSAGEM_VIEWER: "Teste 04",
    VLR_TEMPO_ATUALIZACAO: 40,
    PRD057_ASSOC_MODELO_PAR_MAQ: [{ SEQ_PARTE_MAQUINA: 1 }]
  },
  {
    SEQ_MODELO_VIEWER: 8,
    COD_MODELO_VIEWER: "05",
    TIP_MODELO: 5,
    DSC_MENSAGEM_VIEWER: "Teste de versão do sistema Viewer-DA.",
    VLR_TEMPO_ATUALIZACAO: 50,
    PRD057_ASSOC_MODELO_PAR_MAQ: []
  }
];

export default model;
